 import React from 'react'
 import { connect } from 'react-redux';
import { Checkbox, message } from 'antd';
import { fetchServer } from './modelManager'
//import moment from 'moment'
//import locale from 'antd/es/date-picker/locale/fr_FR';
import 'moment/locale/fr';
//import { IconExcel } from '../../ressource/svg/excel.svg'
import PropTypes from 'prop-types';




class FilterEnum extends React.Component {
    state = {
        values: [],

    }

    componentDidMount() {
        const request = {
            endPoint: this.props.apiUrl +'/' + this.props.datasource,
            method: 'GET',
            token: this.props.JWTToken
        }
        fetchServer(request,
            (json) => {
                this.setState({ values: json.value })
            },
            error=> message.error(error))
    }

    render() {
        const { values } = this.state
        const selected = [...this.props.selected]
        return (
            <div>
                {
                    values.map((item) => {
                        return (
                            <div key={item[this.props.id]}>
                                <Checkbox
                                    checked={selected.find(value => value === item[this.props.id]) !== undefined}
                                    onChange={e => {
                                        if (e.target.checked === false) {
                                            selected.splice(selected.findIndex(value => value === item[this.props.id]), 1)
                                        } else {
                                            selected.push(item[this.props.id])
                                        }

                                        this.props.onChange(selected)
                                    }}
                                />
                                {item[this.props.libelle]}
                            </div>
                        )
                    })
                }
            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return ({
        JWTToken: state.authentication.JWTToken,
        apiUrl: state.server.apiUrl,
    })
}

export  default connect(mapStateToProps)(FilterEnum)

FilterEnum.propTypes = {
    onChange: PropTypes.func,
    datasource: PropTypes.string,
    selected: PropTypes.array,
    id: PropTypes.string,
    libelle: PropTypes.string, 
    apiUrl : PropTypes.string,
    JWTToken : PropTypes.string
}